/**
 * Page flags and the intro rule (I1). Pure: no DOM at import, so tests can load it.
 *
 *   ?kiosk=1            kiosk shell (B10 reads it too), auto-enter, attract loop
 *   ?qa                 window.__ld (also always in dev) and auto-enter, so QA scripts never click
 *   ?intro=full|short   force the intro (reduced motion still wins: always short)
 *   ?place= / ?cat=     a deep link: the short intro, then the place or the bloom (useUrlSync)
 */
import { kioskFromSearch } from "@/features/layout/layoutMath";

export type IntroMode = "full" | "short";

export interface PageFlags {
  kiosk: boolean;
  qa: boolean;
  deepLink: boolean;
  forcedIntro: IntroMode | null;
}

export function pageFlags(search: string): PageFlags {
  const q = new URLSearchParams(search);
  const forced = q.get("intro");
  return {
    kiosk: kioskFromSearch(search),
    qa: q.has("qa"),
    deepLink: !!(q.get("place") || q.get("cat")),
    forcedIntro: forced === "full" || forced === "short" ? forced : null,
  };
}

/** Full on a first visit; short on a return visit (this session), under reduced motion, or for a deep link. */
export function introModeFor(o: { introSeen: boolean; reduced: boolean; deepLink: boolean; forced?: IntroMode | null }): IntroMode {
  if (o.reduced) return "short";
  if (o.forced) return o.forced;
  return o.introSeen || o.deepLink ? "short" : "full";
}
